import { render, staticRenderFns } from "./SocialMediaFooter.vue?vue&type=template&id=0cabbcf0"
import script from "./SocialMediaFooter.vue?vue&type=script&lang=js"
export * from "./SocialMediaFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports